import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class UserStatusUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getUserStatus(req);
    }
}
export default UserStatusUseCase;
